import DashboardLayout from "@/packages/dashboard/views/DashboardLayout.vue";
import RedeemLoyaltyPoints from "@/packages/WaasModules/LoyaltyPoints/component/RedeemLoyaltyPoints.vue";
import TopUpBeneficiaryPoints from "@/packages/WaasModules/LoyaltyPoints/component/TopUpBeneficiaryPoints.vue";
import SharePointsBeneficiary from "@/packages/WaasModules/LoyaltyPoints/component/SharePointsBeneficiary.vue";
import TransferPointsToMerchant from "@/packages/WaasModules/LoyaltyPoints/component/TransferPointsToMerchant.vue";

const LoyaltyPointsRoutes =[
    {
        path: '/dashboard/waas/loyalty-points',
        component: DashboardLayout,
        children: [
            {
                path: 'redeem',
                component: RedeemLoyaltyPoints,
                name: "RedeemPoints",
                // meta: { middleware: [Auth]},
            },
            {
                path: 'top-up',
                component: TopUpBeneficiaryPoints,
                name: "TopUpBeneficiary",
                // meta: { middleware: [Auth]},
            },
            {
                path: 'share-to-beneficiary',
                component: SharePointsBeneficiary,
                name: "ShareToBeneficiary",
                // meta: { middleware: [Auth]},
            },
            {
                path: 'transfer-to-merchant',
                component: TransferPointsToMerchant,
                name: "TransferPoints",
                // meta: { middleware: [Auth]},
            },
        ]
    }
];
export default LoyaltyPointsRoutes;
